import React from 'react';

export function useEndReached(onReach: () => void, enabled: boolean, margin = '600px') {
    const ref = React.useRef<HTMLDivElement | null>(null);
    const latest = React.useRef(onReach);
    latest.current = onReach;

    React.useEffect(() => {
        const node = ref.current;
        if (!enabled || !node || typeof IntersectionObserver === 'undefined') return undefined;

        const observer = new IntersectionObserver((entries) => {
            if (entries.some((entry) => entry.isIntersecting)) latest.current();
        }, { rootMargin: `0px 0px ${margin} 0px` });

        observer.observe(node);
        return () => observer.disconnect();
    }, [enabled, margin]);

    return ref;
}

export default useEndReached;
